
























































import { Component, Vue } from 'vue-property-decorator';
import { RealmsModule } from '@/store/modules/realms/realms.store';
import { SelectPair } from '@/core/types';
import { MapGameRole } from '@/core/constants';

import UpdateRealmName from '@/components/dashboard/realms/UpdateRealmName.vue';
import UpdateRealmSecurity from '@/components/dashboard/realms/UpdateRealmSecurity.vue';
import RunServerScript from '@/components/dashboard/realms/RunServerScript.vue';
import RestartServer from '@/components/dashboard/realms/RestartServer.vue';
import UploadWoWExe from '@/components/dashboard/realms/UploadWoWExe.vue';
import UploadDBC from '@/components/dashboard/realms/UploadDBC.vue';
import DownloadDBC from '@/components/dashboard/realms/DownloadDBC.vue';
import UploadPatch from '@/components/dashboard/realms/UploadPatch.vue';
import UploadMaps from '@/components/dashboard/realms/UploadMaps.vue';
import UploadLuaFiles from '@/components/dashboard/realms/UploadLuaFiles.vue';
import DeleteLUAFiles from '@/components/dashboard/realms/DeleteLUAFiles.vue';
import DeletePatchFiles from '@/components/dashboard/realms/DeletePatchFiles.vue';
import DeleteWoWExe from '@/components/dashboard/realms/DeleteWoWExe.vue';
import EditPatches from '@/components/dashboard/realms/EditPatches.vue';
import { GameRole } from '@/types/apiServerContract';

@Component({
    components: {
        UpdateRealmName,
        UpdateRealmSecurity,
        RunServerScript,
        RestartServer,
        UploadWoWExe,
        UploadDBC,
        DownloadDBC,
        UploadPatch,
        UploadMaps,
        UploadLuaFiles,
        DeleteLUAFiles,
        DeleteWoWExe,
        DeletePatchFiles,
        EditPatches
    }
})
export default class Realm extends Vue {
    get realm() {
        return RealmsModule.ActiveRealm;
    }

    get SecurityRoles() {
        const icons: SelectPair[] = [
            {
                value: -1,
                text: 'Select Access Level'
            }
        ];

        for (const n in GameRole) {
            const val = GameRole[n] as any;
            if (isNaN(val)) continue;

            icons.push({
                value: val,
                text: MapGameRole(val)
            });
        }
        return icons;
    }

    MapGameRole(role: GameRole) {
        return MapGameRole(role);
    }
}
